import { Record, List } from 'immutable';

export default class ReplacementModelRecord extends Record({
  id: null,
  name: null,
  periods: new List(),
  term: null,
  forSelfEmployed: false,
  archived: false,
  // Article-based agreements: 'price_list' (default) | 'article_based'.
  mode: 'price_list',
  // Customer "Basera på ersättningsavtal": id of the source payout model.
  derivedFromResourceModel: undefined,
  // Customer "Basera på ersättningsavtal" toggle — derive prices from the
  // booking's payout agreement (no own price rows).
  basedOnResourceAgreement: false,
  // Customer-side debit factor override: a base factor that carries to every
  // segment (null = catalog factor), plus optional per-article exceptions.
  baseDebitFactor: undefined,
  debitFactorOverrides: undefined,
  links: new List(),
  confirmedBookingsCount: undefined,
}) {
}
